"use strict";

exports.__esModule = true;
exports.CommentWordCountWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CommentWordCountElement = require("./CommentWordCountElement");
var _CommentWordCountFields = require("./CommentWordCountFields");
var _CommentWordCountThumbnail = require("./CommentWordCountThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CommentWordCountWidget = exports.CommentWordCountWidget = {
  name: "CommentWordCount",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CommentWordCountWidget.label",
    defaultMessage: "Comment Word Count"
  }),
  icon: "comparison",
  group: _widgetGroups.DIGITAL_LOG_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "CommentWordCount",
      props: Object.assign({
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _CommentWordCountElement.CommentWordCountElement,
    Fields: _CommentWordCountFields.CommentWordCountFields,
    Thumbnail: _CommentWordCountThumbnail.CommentWordCountThumbnail
  }
};